export const translations = {
  // Header / Navigation
  nav: {
    about: { it: 'Chi siamo', ru: 'О нас' },
    products: { it: 'Prodotti', ru: 'Продукты' },
    features: { it: 'Vantaggi', ru: 'Преимущества' },
    gallery: { it: 'Galleria', ru: 'Галерея' },
    contact: { it: 'Contatti', ru: 'Контакты' },
    call: { it: 'Chiama', ru: 'Позвонить' },
    consultation: { it: 'Consulenza gratuita', ru: 'Бесплатная консультация' }
  },

  // Hero section
  hero: {
    title: { it: 'Radiatori a infrarossi in vetro', ru: 'Инфракрасные стеклянные радиаторы' },
    subtitle: { it: 'Scopri il comfort del riscaldamento intelligente: design elegante, risparmio energetico e controllo totale da smartphone', ru: 'Откройте для себя комфорт умного отопления: элегантный дизайн, энергосбережение и полный контроль со смартфона' },
    features: [
      { it: 'Risparmio energetico fino al 40%', ru: 'Экономия электроэнергии до 40%' },
      { it: 'Consumo medio 250-300W (meno di 1 kW!)', ru: 'Среднее потребление 250-300Вт (менее 1 кВт!)' },
      { it: 'Controllo WiFi da qualsiasi luogo', ru: 'WiFi управление из любой точки' },
      { it: 'Design ultrasottile 11mm', ru: 'Ультратонкий дизайн 11мм' },
      { it: 'Garanzia 5 anni', ru: 'Гарантия 5 лет' }
    ],
    learnMore: { it: 'Scopri di più', ru: 'Узнать больше' },
    catalog: { it: 'Vedi i prodotti', ru: 'Смотреть продукты' },
    badgeTitle: { it: 'Showroom a Battipaglia', ru: 'Шоурум в Баттипалья' },
    badgeText: { it: 'Tocca con mano i prodotti GPO', ru: 'Оцените продукты GPO вживую' }
  },

  // About / Intro section
  about: {
    title: { it: 'Cosa sono i radiatori GPO?', ru: 'Что такое радиаторы GPO?' },
    subtitle: { it: 'Una nuova generazione di riscaldamento domestico', ru: 'Новое поколение домашнего отопления' },
    intro: { it: 'I radiatori GPO sono pannelli riscaldanti in vetro temperato che combinano tecnologia a infrarossi e convezione. A differenza dei tradizionali radiatori, riscaldano direttamente oggetti e persone, creando un comfort immediato con un consumo energetico ridotto.', ru: 'Радиаторы GPO — это отопительные панели из закаленного стекла, сочетающие инфракрасную технологию и конвекцию. В отличие от традиционных радиаторов, они напрямую нагревают предметы и людей, создавая мгновенный комфорт при сниженном энергопотреблении.' },
    point1Title: { it: 'Come funziona?', ru: 'Как это работает?' },
    point1Desc: { it: 'Il 60-70% del calore viene emesso come radiazione infrarossa (come il sole), mentre il 30-40% riscalda l\'aria per convezione naturale.', ru: '60-70% тепла излучается в виде инфракрасного излучения (как солнце), а 30-40% нагревает воздух за счет естественной конвекции.' },
    point2Title: { it: 'Perché è efficiente?', ru: 'Почему это эффективно?' },
    point2Desc: { it: 'Il termostato integrato mantiene la temperatura esatta impostata, evitando sprechi. Il consumo reale è di 250-300W/h invece dei 500-670W nominali.', ru: 'Встроенный термостат поддерживает точную заданную температуру, избегая перерасхода. Реальное потребление составляет 250-300Вт/ч вместо номинальных 500-670Вт.' },
    point3Title: { it: 'Per chi è adatto?', ru: 'Для кого это подходит?' },
    point3Desc: { it: 'Ideale per appartamenti, case vacanza, uffici, bagni. Perfetto per chi cerca un riscaldamento supplementare efficiente o un\'alternativa ai sistemi tradizionali.', ru: 'Идеально для квартир, загородных домов, офисов, ванных комнат. Отлично подходит тем, кто ищет эффективный дополнительный обогрев или альтернативу традиционным системам.' }
  },

  // Energy Savings section
  savings: {
    title: { it: 'Quanto puoi risparmiare?', ru: 'Сколько вы можете сэкономить?' },
    subtitle: { it: 'Esempi reali di risparmio energetico con GPO', ru: 'Реальные примеры экономии энергии с GPO' },
    example1Title: { it: 'Camera da letto 10 m²', ru: 'Спальня 10 м²' },
    example1Model: { it: 'Modello: G50 (500W)', ru: 'Модель: G50 (500Вт)' },
    example1Consumption: { it: 'Consumo medio: 250W/h', ru: 'Среднее потребление: 250Вт/ч' },
    example1Cost: { it: 'Costo per 8 ore: ~€0,50', ru: 'Стоимость за 8 часов: ~€0,50' },
    example2Title: { it: 'Soggiorno 15 m²', ru: 'Гостиная 15 м²' },
    example2Model: { it: 'Modello: G67 (670W)', ru: 'Модель: G67 (670Вт)' },
    example2Consumption: { it: 'Consumo medio: 300W/h', ru: 'Среднее потребление: 300Вт/ч' },
    example2Cost: { it: 'Costo per 8 ore: ~€0,60', ru: 'Стоимость за 8 часов: ~€0,60' },
    example3Title: { it: 'Bagno 5 m²', ru: 'Ванная 5 м²' },
    example3Model: { it: 'Modello: T50 (500W)', ru: 'Модель: T50 (500Вт)' },
    example3Consumption: { it: 'Consumo medio: 200W/h', ru: 'Среднее потребление: 200Вт/ч' },
    example3Cost: { it: 'Costo per 2 ore: ~€0,10', ru: 'Стоимость за 2 часа: ~€0,10' },
    note: { it: '* Calcoli basati su tariffa media €0,25/kWh. I costi effettivi dipendono dalla tariffa del fornitore.', ru: '* Расчеты основаны на средней тарифе €0,25/кВтч. Фактические затраты зависят от тарифа вашего поставщика.' },
    keyPoint: { it: 'Tutti i nostri radiatori consumano meno di 1 kW!', ru: 'Все наши радиаторы потребляют менее 1 кВт!' },
    comparison: { it: 'Confronto: un calorifero tradizionale da 2000W costa ~€4 per 8 ore', ru: 'Сравнение: традиционный обогреватель 2000Вт стоит ~€4 за 8 часов' }
  },

  // Producer / Showroom section
  producer: {
    title: { it: 'Produttore', ru: 'Производитель' },
    text: { it: 'Le innovazioni firmate GPO (GREEN POWER ORIENTED) sono disponibili a Battipaglia. Lo showroom Perfectwin è il partner diretto e distributore ufficiale del brand. Ti invitiamo a visitare la nostra esposizione per toccare con mano l\'efficienza delle soluzioni GPO e ricevere una consulenza su misura direttamente dal produttore.', ru: 'Инновации под маркой GPO (GREEN POWER ORIENTED) доступны в Баттипалья. Шоурум Perfectwin является прямым партнером и официальным дистрибьютором бренда. Приглашаем вас посетить нашу выставку, чтобы лично оценить эффективность решений GPO и получить индивидуальную консультацию непосредственно от производителя.' },
    visitUs: { it: 'Vieni a trovarci', ru: 'Приходите к нам' },
    address: { it: 'Via Belvedere, 59 - Battipaglia (SA)', ru: 'Via Belvedere, 59 - Battipaglia (SA)' }
  },

  // Contact Form
  contactForm: {
    title: { it: 'Richiedi informazioni', ru: 'Запросить информацию' },
    subtitle: { it: 'Compila il modulo e ti ricontatteremo entro 24 ore', ru: 'Заполните форму и мы свяжемся с вами в течение 24 часов' },
    name: { it: 'Nome e cognome', ru: 'Имя и фамилия' },
    namePlaceholder: { it: 'Il tuo nome', ru: 'Ваше имя' },
    phone: { it: 'Telefono', ru: 'Телефон' },
    phonePlaceholder: { it: '+39 ...', ru: '+39 ...' },
    email: { it: 'Email', ru: 'Email' },
    emailPlaceholder: { it: 'tua@email.com', ru: 'ваш@email.com' },
    question: { it: 'La tua domanda', ru: 'Ваш вопрос' },
    questionPlaceholder: { it: 'Scrivi qui la tua domanda o richiesta...', ru: 'Напишите здесь ваш вопрос или запрос...' },
    submit: { it: 'Invia richiesta', ru: 'Отправить запрос' },
    sending: { it: 'Invio in corso...', ru: 'Отправка...' },
    success: { it: 'Grazie! Ti ricontatteremo presto.', ru: 'Спасибо! Мы скоро свяжемся с вами.' },
    error: { it: 'Si è verificato un errore. Riprova o chiamaci direttamente.', ru: 'Произошла ошибка. Попробуйте снова или позвоните нам.' },
    privacy: { it: 'Inviando il modulo accetti la nostra politica sulla privacy', ru: 'Отправляя форму, вы соглашаетесь с нашей политикой конфиденциальности' }
  },

  // Features section
  features: {
    title: { it: 'Perch\u00E9 scegliere GPO', ru: 'Почему выбирают GPO' },
    highlightTitle: { it: 'Speciale per gli scaldasalviette', ru: 'Специально для полотенцесушителей' },
    highlight1Title: { it: "Riscaldamento dell'intera piastra", ru: 'Нагрев всей пластины' },
    highlight1Desc: { it: "L'intera superficie in vetro irradia calore, non solo le barre", ru: 'Вся стеклянная поверхность излучает тепло, а не только перекладины' },
    highlight2Title: { it: 'Acciaio inossidabile', ru: 'Нержавеющая сталь' },
    highlight2Desc: { it: 'Le barre in acciaio inossidabile non arrugginiscono e sopportano carichi elevati', ru: 'Перекладины из нержавеющей стали не ржавеют и выдерживают большую нагрузку' },
    highlight3Title: { it: 'Asciugatura biancheria', ru: 'Сушка белья' },
    highlight3Desc: { it: 'Asciuga rapidamente asciugamani e vestiti mantenendo il bagno caldo', ru: 'Быстро сушит полотенца и одежду, поддерживая тепло в ванной комнате' }
  },

  // Product Catalog
  productCatalog: {
    title: { it: 'Radiatori per ambienti', ru: 'Обогреватели для помещений' },
    subtitle: { it: 'Pannelli radianti premium in vetro con controllo WiFi', ru: 'Премиальные стеклянные панельные обогреватели с WiFi управлением' },
    techTitle: { it: 'Tecnologia di riscaldamento', ru: 'Технология нагрева' },
    techIntro: { it: "I nostri radiatori utilizzano una combinazione di radiazione infrarossa e flussi d'aria convettivi:", ru: 'Наши обогреватели используют комбинацию инфракрасного излучения и конвективных потоков воздуха:' },
    techPoints: [
      {
        it: '<strong>Riscaldamento rapido</strong> grazie all\'ampia superficie di contatto con l\'aria',
        ru: '<strong>Быстрый нагрев</strong> благодаря большой площади контакта с воздухом'
      },
      {
        it: '<strong>Miscelazione uniforme</strong> dell\'aria per una temperatura equilibrata nell\'ambiente',
        ru: '<strong>Равномерное перемешивание</strong> воздуха для сбалансированной температуры в помещении'
      },
      {
        it: '<strong>Efficienza energetica</strong> - consumo 250-300W/h invece dei 500-670W dichiarati',
        ru: '<strong>Энергоэффективность</strong> - потребление 250-300Вт/ч вместо заявленных 500-670Вт'
      }
    ]
  },

  // Product Card
  productCard: {
    viewGallery: { it: 'Clicca per visualizzare la galleria', ru: 'Нажмите для просмотра галереи' },
    model: { it: 'Modello', ru: 'Модель' },
    power: { it: 'Potenza', ru: 'Мощность' },
    area: { it: 'Area', ru: 'Площадь' },
    size: { it: 'Dimensioni', ru: 'Размер' },
    control: { it: 'Controllo', ru: 'Управление' },
    materials: { it: 'Materiali', ru: 'Материалы' },
    installation: { it: 'Installazione', ru: 'Установка' },
    order: { it: 'Saperne di più', ru: 'Узнать больше' }
  },

  // Towel Dryers
  towelDryers: {
    title: { it: 'Scaldasalviette-Radiatori', ru: 'Полотенцесушители-обогреватели' },
    subtitle: { it: '2 in 1: asciugatura asciugamani e riscaldamento bagno', ru: '2 в 1: сушка полотенец и обогрев ванной комнаты' },
    extraTitle: { it: 'Prodotti aggiuntivi', ru: 'Дополнительные продукты' },
    shoeDryersTitle: { it: 'Asciugascarpe', ru: 'Сушилки для обуви' }
  },

  // Usage Gallery
  gallery: {
    title: { it: "Galleria d'uso", ru: 'Галерея использования' },
    subtitle: { it: 'Foto reali dei radiatori GPO negli interni e infografiche sui prodotti', ru: 'Реальные фотографии обогревателей GPO в интерьерах и инфографика о продуктах' },
    clickToView: { it: 'Clicca su qualsiasi immagine per visualizzarla a schermo intero', ru: 'Нажмите на любое изображение для просмотра в полном размере' },
    imageAlts: {
      heaterInterior: { it: 'Radiatore GPO in interni', ru: 'Обогреватель GPO в интерьере' },
      heaterLiving: { it: 'Radiatore in soggiorno moderno', ru: 'Обогреватель в современной гостиной' },
      heaterBedroom: { it: 'Radiatore in camera da letto', ru: 'Обогреватель в спальне' },
      heaterOffice: { it: 'Radiatore in ufficio', ru: 'Обогреватель в офисе' },
      towelDryerBathroom: { it: 'Scaldasalviette in bagno', ru: 'Полотенцесушитель в ванной' },
      infographic: { it: 'Infografica prodotto GPO', ru: 'Инфографика продукта GPO' }
    }
  },

  // Image Gallery Modal
  imageGallery: {
    model: { it: 'Modello', ru: 'Модель' },
    power: { it: 'Potenza', ru: 'Мощность' },
    heatingArea: { it: 'Area di riscaldamento', ru: 'Площадь обогрева' },
    dimensions: { it: 'Dimensioni', ru: 'Размеры' },
    materials: { it: 'Materiali', ru: 'Материалы' },
    learnMore: { it: 'Saperne di più', ru: 'Узнать больше' }
  },

  // Call to Action
  cta: {
    title: { it: 'Pronti a rendere la vostra casa pi\u00F9 calda?', ru: 'Готовы сделать ваш дом теплее?' },
    text: { it: 'Contattateci per una consulenza e un preventivo per il sistema di riscaldamento della vostra casa a Salerno', ru: 'Свяжитесь с нами для консультации и расчета стоимости системы отопления для вашего дома в Салерно' },
    phoneLabel: { it: 'Telefono per ordini', ru: 'Телефон для заказа' },
    emailLabel: { it: 'Email', ru: 'Email' },
    addressLabel: { it: 'Indirizzo', ru: 'Адрес' },
    callNow: { it: 'Chiama ora', ru: 'Позвонить сейчас' },
    note: { it: 'Lavoriamo tutti i giorni \u2022 Consulenza gratuita \u2022 Garanzia 5 anni', ru: 'Работаем ежедневно \u2022 Консультация бесплатно \u2022 Гарантия 5 лет' },
    features: [
      { it: 'Consulenza gratuita', ru: 'Бесплатная консультация' },
      { it: 'Consegna veloce nella regione', ru: 'Быстрая доставка по региону' },
      { it: 'Assistenza all\'installazione', ru: 'Помощь с установкой' },
      { it: 'Garanzia ufficiale 5 anni', ru: 'Официальная гарантия 5 лет' }
    ]
  },

  // Footer
  footer: {
    description: { it: 'Sistemi di riscaldamento premium di qualità europea. Distributore ufficiale per Salerno e provincia.', ru: 'Премиальные системы отопления европейского качества. Официальный дистрибьютор в Салерно и провинции.' },
    officeItaly: { it: 'Showroom Italia', ru: 'Шоурум Италия' },
    manufacturer: { it: 'Azienda', ru: 'Компания' },
    advantages: { it: 'Vantaggi', ru: 'Преимущества' },
    advantagesList: [
      { it: 'Garanzia 5 anni', ru: 'Гарантия 5 лет' },
      { it: 'Consulenza gratuita', ru: 'Бесплатная консультация' },
      { it: 'Consegna in provincia', ru: 'Доставка по провинции' },
      { it: 'Supporto in italiano', ru: 'Поддержка на итальянском' },
      { it: 'Certificato CE', ru: 'Сертификат CE' }
    ],
    copyright: { it: '© 2024 GPO OÜ. Tutti i diritti riservati. Qualità europea', ru: '© 2024 GPO OÜ. Все права защищены. Европейское качество' },
    bottomLinks: [
      { it: 'Battipaglia, Salerno', ru: 'Баттипалья, Салерно' },
      { it: 'Riscaldamento intelligente', ru: 'Умное отопление' },
      { it: 'Risparmio energetico', ru: 'Энергосбережение' }
    ]
  }
};
